import { findLast, findLastIndex } from 'lodash';

import { Cell, ChatExploration, ChatMessage, ChatSource } from '@/explore/types';
import { belongsToConversation, isChatCell, isUserQuestionMessage } from '@/core/cell';

const supportedIntegrations = [
  'confluence',
  'custom_unstructured',
  'google_drive',
  'notion',
  'slack',
];

export function discardClearsView(cells: Cell[], conversationId: string) {
  const lastInputCell = findLast(
    cells,
    (c) =>
      belongsToConversation(c, conversationId) &&
      isChatCell(c) &&
      c.messages.some((m) => m.role === 'user'),
  );
  if (lastInputCell === undefined || !isChatCell(lastInputCell)) {
    return false;
  }

  const discardingFirstChatCell = cells.indexOf(lastInputCell) === 0;
  const onlySingleUserMessage =
    findLastIndex(lastInputCell.messages, (msg) => msg.role === 'user') === 0;
  const explorationContainsOtherCells = cells.some(
    (c) => !belongsToConversation(c, conversationId),
  );

  return discardingFirstChatCell && onlySingleUserMessage && !explorationContainsOtherCells;
}

export const getAvailableSources = (integrations: { service: string }[], models: Array<any>) => [
  ...(models.length > 0 ? [ChatSource.Database] : []),
  ...integrations
    .filter(({ service }) => supportedIntegrations.includes(service))
    .map(({ service }) => service),
];

export const ensureValidSources = (sources: string[], availableSources: string[]) => {
  return sources.filter((source) => availableSources.includes(source));
};

export const ensureValidMessage = (
  message: ChatMessage | ChatExploration,
  availableSources: string[],
) => {
  return isUserQuestionMessage(message)
    ? {
        ...message,
        sources: ensureValidSources(message.sources ?? [], availableSources),
      }
    : message;
};
